export default __webpack_public_path__ + "static/like-241c62dbe76fce36f73bf3b75fbc258e.gif";